<template>
  <div>
    <AppHeader @refreshPage="init" />
    <div class="container">
      <div class="page-title" style="margin-bottom: 0.1rem">
        {{ $t('income') }}
      </div>
      <mt-navbar v-model="selected">
        <mt-tab-item id="1" clss="up">{{ $t('hotnfts') }}</mt-tab-item>
        <mt-tab-item id="2" clss="up">{{ $t('activities') }}</mt-tab-item>
      </mt-navbar>
      <!-- tab-container -->
      <mt-tab-container v-model="selected">
        <mt-tab-container-item id="1">
          <div class="list1" v-if="hotNfts && hotNfts.length > 0">
            <div class="item" v-for="(item, index) in hotNfts" :key="index">
              <div class="flexable top" style="position: relative">
                <div
                  class="img2"
                  :style="{
                    backgroundImage:
                      'url(' + $store.state.imgUrl + item.image + ')'
                  }"
                  @click="handleRoute2('/user/nftdetail', item)"></div>
                <div class="activity-info">
                  <div
                    class="name"
                    @click="handleRoute2('/user/nftdetail', item)">
                    {{ item.name }}
                  </div>
                  <div class="price2">{{ item.income }}</div>
                  <div class="share" @click="handleShare('nft', item)">
                    <span> {{ $t('share') }}</span>
                  </div>
                </div>
              </div>
              <div class="total-box flexable">
                <div class="total">
                  <b>{{ item.payment }}</b
                  ><br />
                  {{ $t('payment') }}
                </div>
                <div class="total">
                  <b>{{ item.participants }}</b
                  ><br />
                  {{ $t('participants') }}
                </div>
                <div class="total">
                  <b>{{ item.commission }}</b
                  ><br />
                  {{ $t('commission') }}
                </div>
                <div class="total">
                  <b>{{ item.income }}</b
                  ><br />
                  {{ $t('income') }}
                </div>
              </div>
            </div>
          </div>
          <EmptyBox
            :text="$t('nonft')"
            type="nft"
            v-if="hotNfts && hotNfts.length === 0" />
        </mt-tab-container-item>
        <mt-tab-container-item id="2">
          <div class="list1" v-if="activities && activities.length > 0">
            <div class="item" v-for="(item, index) in activities" :key="index">
              <div class="flexable top" style="position: relative">
                <div
                  class="img"
                  @click="handleRoute('/user/actdetail', item)"
                  :style="{
                    backgroundImage:
                      'url(' + $store.state.imgUrl + item.image + ')'
                  }"></div>
                <div class="activity-info">
                  <div
                    class="name"
                    @click="handleRoute('/user/actdetail', item)">
                    {{ item.name }}
                  </div>
                  <div class="date">{{ item.date }}</div>
                  <div class="status-component" :class="'status' + item.status">
                    {{ item.statusName }}
                  </div>
                  <div class="share" @click="handleShare('act', item)">
                    <span> {{ $t('share') }}</span>
                  </div>
                </div>
              </div>
              <div class="total-box flexable">
                <div class="total">
                  <b>{{ item.payment }}</b
                  ><br />
                  {{ $t('payment') }}
                </div>
                <div class="total">
                  <b>{{ item.participants }}</b
                  ><br />
                  {{ $t('participants') }}
                </div>
                <div class="total">
                  <b>{{ item.commission }}</b
                  ><br />
                  {{ $t('commission') }}
                </div>
                <div class="total">
                  <b>{{ item.income }}</b
                  ><br />
                  {{ $t('income') }}
                </div>
              </div>
            </div>
          </div>
          <EmptyBox
            v-if="activities && activities.length === 0"
            type="act"
            :text="$t('noactivity')" />
        </mt-tab-container-item>
      </mt-tab-container>
    </div>
    <mt-popup
      v-model="popupVisible"
      position="bottom"
      :closeOnClickModal="false">
      <SharePop
        :sharePath="sharePath"
        @cancel="
          () => {
            this.popupVisible = false
          }
        "
        v-if="popType === 'share'" />
      <div
        class="pop-close"
        @click="
          () => {
            this.popupVisible = false
          }
        "></div>
    </mt-popup>
  </div>
</template>
<script>
import { postActivityMyPromotions, postNftMyPromotions } from '@/api/user'
import EmptyBox from '@/components/EmptyBox.vue'
import SharePop from '@/components/SharePop.vue'

export default {
  name: 'UserIncome',
  components: {
    SharePop,
    EmptyBox
  },
  data() {
    return {
      selected: '1',
      popupVisible: false,
      hotNfts: null,
      activities: null,
      queryParams: {
        page: 1,
        size: 10
      },
      sharePath: ''
    }
  },
  watch: {
    popupVisible: {
      handler(n) {
        this.$stopScroll(n)
      },
      deep: true
    },
    '$i18n.locale'() {
      this.init()
    }
  },
  created() {
    this.init()
  },
  beforeRouteLeave(to, from, next) {
    if (to.name !== 'UserNftDetail' && to.name !== 'UserActDetail') {
      this.$store.commit('SET_KEEP_ALIVE', [])
    }
    next()
  },
  methods: {
    init() {
      postActivityMyPromotions(this.queryParams)
        .then((res) => {
          this.activities = res.data
        })
        .catch(() => {})
      postNftMyPromotions(this.queryParams)
        .then((res) => {
          this.hotNfts = res.data
        })
        .catch(() => {})
    },
    handleShare(type, item) {
      if (type === 'nft') {
        this.sharePath =
          this.$store.state.userPath +
          '/user/nftdetail?inviteCode=' +
          this.$store.state.user_info.rec_code +
          '&inviteNft=' +
          item.rec_code +
          '&rec_code=' +
          item.rec_code
      } else if (type === 'act') {
        this.sharePath =
          this.$store.state.userPath +
          '/user/activity?inviteCode=' +
          this.$store.state.user_info.rec_code +
          '&inviteAct=' +
          item.rec_code +
          '&rec_code=' +
          item.rec_code
      }
      this.popType = 'share'
      this.popupVisible = true
    },
    handleRoute(path, item) {
      this.$router.push({
        path: path,
        query: { rec_code: item.rec_code }
      })
    },
    handleRoute2(path, item) {
      this.$router.push({ path: path, query: { rec_code: item.rec_code } })
    }
  }
}
</script>
<style scoped lang="scss">
.list1 .item .total-box {
  margin-top: 0.2rem;
}
</style>



// WEBPACK FOOTER //
// src/views/user/income.vue